import { useMutation } from '@tanstack/react-query'
import { brandingApi, BrandingConfigPayload } from '../api/branding.api'
import { brandingKeys } from '../api/branding.keys'

export function useUpdateBranding() {
    return useMutation<void, Error, BrandingConfigPayload>({
        mutationKey: brandingKeys.updateConfig,
        mutationFn: brandingApi.updateBrandingConfig,
    })
}
